import api from '../api';

export const surfacesFetchSuccess = (surfaces) => {
    return {
        type: 'SURFACES_FETCH_SUCCESS',
        surfaces
    };
};

export function loadSurfaces() {
    return (dispatch) => {
        return api.getSurfaces().then(response => {
            dispatch(surfacesFetchSuccess(response));
        }).catch(error => {
            throw(error);
        });
    };
}

export function getSurface(surface_slug, state) {
    let surface = {
        name: "floor"
    };
    if(state.surfaces.length > 0) {

        surface = state.surfaces.reduce(function(surface, item) {
            return item.slug == surface_slug ? item : surface;
        }, surface);

    }

    return surface;
}



// WEBPACK FOOTER //
// ./src/actions/surfaceActions.js